export const isSupportedBrowser = () => {
	const {
		userAgent: ua = ""
	} = window.navigator || {};

	if (ua.indexOf("MSIE") > -1 || ua.indexOf("Trident/") > -1) {
		return false;
	}

	return true;
};
